$(document).ready(function() {
	
	var testimonials_groups = $('.ps-testimonials-group');
	$(testimonials_groups).each(function(index, group) {
		var $carousel = $(group).flickity({
			autoPlay: true,
			cellAlign: 'center',
			wrapAround: true
		});
	});
		
});